import { render } from "./CreateWaybillModal.vue?vue&type=template&id=05d3166c"
import script from "./CreateWaybillModal.vue?vue&type=script&lang=js"
export * from "./CreateWaybillModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__